import PageShell from "@/components/PageShell";
import useSEO, { orgSchema, breadcrumbSchema } from "@/lib/useSEO";

export default function Privacy() {
  useSEO({
    title: "Privacy Policy — PixelEmpire AI",
    description:
      "How PixelEmpire AI collects, uses, and protects your personal data. GDPR/CCPA compliant. No re-selling of user data.",
    path: "/privacy",
    jsonLd: [
      orgSchema,
      breadcrumbSchema([
        { name: "Home", url: "/" },
        { name: "Privacy", url: "/privacy" },
      ]),
    ],
  });

  return (
    <PageShell testId="page-privacy">
      <div className="pill" data-testid="privacy-pill"><span>Legal · Privacy</span></div>
      <h1 className="mt-4 font-display text-4xl sm:text-5xl leading-tight text-white" data-testid="privacy-h1">
        Privacy Policy
      </h1>
      <p className="mt-4 text-sm text-[var(--fg-muted)]">Last updated: February 2026</p>

      <div className="prose-lux mt-8 space-y-6 text-[var(--fg-muted)] leading-relaxed">
        <section>
          <h2 className="font-display text-2xl text-white">1. What we collect</h2>
          <p className="mt-3">
            When you register we collect your email, a hashed password (bcrypt — we never see the
            raw password), and any brand info you voluntarily provide (logo, business name, URL,
            description, category, country). When you buy a block we also process payment via
            Stripe — we never see or store card numbers ourselves.
          </p>
        </section>
        <section>
          <h2 className="font-display text-2xl text-white">2. What we use it for</h2>
          <p className="mt-3">
            To run your account, publish your ad, send critical updates, and provide analytics.
            Not sold. Not re-shared. Not used to train third-party AI models.
          </p>
        </section>
        <section>
          <h2 className="font-display text-2xl text-white">3. Cookies</h2>
          <p className="mt-3">
            We use a single httpOnly cookie for authentication (JWT). Optional analytics uses
            Google Analytics 4 with IP anonymization enabled. You can opt out via your browser
            settings or the Do-Not-Track signal.
          </p>
        </section>
        <section>
          <h2 className="font-display text-2xl text-white">4. Third parties</h2>
          <p className="mt-3">
            Our subprocessors are limited to: Stripe (payments), MongoDB Atlas (database), Emergent
            (hosting), Cloudflare (CDN + SSL), and Google Analytics (optional traffic stats). Each
            has its own privacy commitments.
          </p>
        </section>
        <section>
          <h2 className="font-display text-2xl text-white">5. Your rights</h2>
          <p className="mt-3">
            Under GDPR/CCPA you can request a data export or full deletion at any time by
            emailing <a href="mailto:privacy@pixel-empires.com" className="text-cyan-300 underline">privacy@pixel-empires.com</a>.
            Deletion of your account removes all personal data within 30 days. Blocks you've paid
            for remain live unless you also request their removal.
          </p>
        </section>
        <section>
          <h2 className="font-display text-2xl text-white">6. Contact</h2>
          <p className="mt-3">
            Questions? <a href="mailto:privacy@pixel-empires.com" className="text-cyan-300 underline">privacy@pixel-empires.com</a>
          </p>
        </section>
      </div>
    </PageShell>
  );
}
